import React from "react";
import dynamic from "next/dynamic";

const UIIcon = dynamic(() => import("../UIElements.js"));

function UIFormButton({
  children,
  htmlType = "button",
  icon,
  type = "primary",
  onClick = () => {},
  full = false,
  className = "",
  loading = false,
  iconSize,
  iconColor,
  style = {},
}) {
  const defaultStyle = {
    backgroundColor: type === "primary" ? "#2364ae" : "transparent",
    border: `1px solid #2364ae`,
    color: type === "primary" ? "#fff" : "#2364ae",
    borderRadius: ".5rem",
    height: "40px",
    ...style,
  };

  return (
    <div className="d-flex justify-content-center">
      <button
        type={htmlType}
        className={`btn ${full ? "w-100" : ""} ${className}`}
        onClick={onClick}
        disabled={loading}
        style={defaultStyle}
      >
        {loading && (
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          />
        )}
        {!loading && icon && (
          <UIIcon Icon={icon} size={iconSize} iconColor={iconColor} />
        )}
        <span className={icon || loading ? `icon-text` : ``}>
          {children}
        </span>
      </button>
    </div>
  );
}

export default UIFormButton;
